"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.apiFactory = void 0;
const http_1 = require("./http");
const authentication_1 = __importDefault(require("./authentication"));
const fx_1 = __importDefault(require("./fx"));
const market_insight_1 = __importDefault(require("./market-insight"));
const googlemapsapi_1 = __importDefault(require("./googlemapsapi"));
const ical_1 = __importDefault(require("./ical"));
const smartPricing_1 = __importDefault(require("./smartPricing"));
const listingIssues_1 = __importDefault(require("./listingIssues"));
const BASE_URL = process.env.API_URL || 'API_URL NOT SET';
const LOCAL_DEV = !!process.env.LOCAL_DEV;
const userJwt = (local) => __awaiter(void 0, void 0, void 0, function* () {
    var _a;
    if (local) {
        // In local development mode, the JWT that is used to boostrap the UI-entities API client
        // is stored in localStorage: see ./src/dev/store.ts
        return window.localStorage.getItem('jwt');
    }
    else {
        const user = yield api.authentication.getCurrentUser();
        return (_a = user.getSignInUserSession()) === null || _a === void 0 ? void 0 : _a.getIdToken().getJwtToken();
    }
});
const apiFactory = (baseUrl = BASE_URL, local = LOCAL_DEV) => {
    const http = (0, http_1.configureHttp)();
    const googleMapsHttp = (0, http_1.configureHttp)();
    googleMapsHttp.setBaseUrl(process.env.GOOGLE_MAPS_API_URL || 'https://maps.googleapis.com/maps/api/geocode/');
    http.setBaseUrl(baseUrl);
    http.addRequestInterceptor((config) => __awaiter(void 0, void 0, void 0, function* () {
        const jwt = yield userJwt(local);
        config.headers = Object.assign({ 'Authorization': `Bearer ${jwt}` }, config.headers);
        return config;
    }));
    return {
        propertyDescription: {
            getPropertyDescription: (propertyId) => {
                return http.get(`/property-description/${propertyId.toString()}`);
            }
        },
        authentication: (0, authentication_1.default)(),
        fx: (0, fx_1.default)(http),
        ical: (0, ical_1.default)(http),
        marketInsight: (0, market_insight_1.default)(http),
        client: {
            getImageValidation: (propertyId) => {
                return http.get(`/client/image/property/${propertyId}/valid`);
            }
        },
        googleMaps: (0, googlemapsapi_1.default)(googleMapsHttp),
        smartPricing: (0, smartPricing_1.default)(http),
        listingIssues: (0, listingIssues_1.default)(http)
    };
};
exports.apiFactory = apiFactory;
const api = (0, exports.apiFactory)(BASE_URL);
exports.default = api;
//# sourceMappingURL=index.js.map